"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const superstore_1 = require("./superstore");
/** This class simply forwards everything to the super store and wraps results
 *  in promises. */
class SuperStorePromiser {
    constructor(fetcher) {
        this.superStore = new superstore_1.SuperStore();
        if (fetcher) {
            this.superStore.setFetcher(fetcher);
        }
    }
    ////// CONSTRAINT FUNCTIONS ///////
    addConstraint(ownerUri, constraint) {
        return Promise.resolve(this.superStore.addConstraint(ownerUri, constraint));
    }
    addVariable(variable) {
        return Promise.resolve(this.superStore.addVariable(variable));
    }
    activateNewConstraints(constraintUris) {
        return Promise.resolve(this.superStore.activateNewConstraints(constraintUris));
    }
    deactivateConstraints(constraintUris) {
        return Promise.resolve(this.superStore.deactivateConstraints(constraintUris));
    }
    ////// DYMOSTORE FUNCTIONS ////////
    loadOntologies(localPath) {
        return Promise.resolve(this.superStore.loadOntologies(localPath));
    }
    addBasePath(dymoUri, path) {
        return Promise.resolve(this.superStore.addBasePath(dymoUri, path));
    }
    addParameterObserver(dymoUri, parameterType, observer) {
        return Promise.resolve(this.superStore.addParameterObserver(dymoUri, parameterType, observer));
    }
    removeParameterObserver(dymoUri, parameterType, observer) {
        return Promise.resolve(this.superStore.removeParameterObserver(dymoUri, parameterType, observer));
    }
    addTypeObserver(type, observer) {
        return Promise.resolve(this.superStore.addTypeObserver(type, observer));
    }
    addPartsObserver(dymoUri, observer) {
        return Promise.resolve(this.superStore.addPartsObserver(dymoUri, observer));
    }
    removePartsObserver(dymoUri, observer) {
        return Promise.resolve(this.superStore.removePartsObserver(dymoUri, observer));
    }
    addRendering(renderingUri, dymoUri) {
        return Promise.resolve(this.superStore.addRendering(renderingUri, dymoUri));
    }
    addDymo(dymoUri, parentUri, partUri, sourcePath, type) {
        return Promise.resolve(this.superStore.addDymo(dymoUri, parentUri, partUri, sourcePath, type));
    }
    findTopDymos() {
        return Promise.resolve(this.superStore.findTopDymos());
    }
    findAllObjectsInHierarchy(dymoUri) {
        return Promise.resolve(this.superStore.findAllObjectsInHierarchy(dymoUri));
    }
    addPart(dymoUri, partUri) {
        return Promise.resolve(this.superStore.addPart(dymoUri, partUri));
    }
    insertPartAt(dymoUri, partUri, index) {
        return Promise.resolve(this.superStore.insertPartAt(dymoUri, partUri, index));
    }
    removeParts(dymoUri, index) {
        return Promise.resolve(this.superStore.removeParts(dymoUri, index));
    }
    findParts(dymoUri) {
        return Promise.resolve(this.superStore.findParts(dymoUri));
    }
    findPartAt(dymoUri, index) {
        return Promise.resolve(this.superStore.findPartAt(dymoUri, index));
    }
    findAllParents(dymoUri) {
        return Promise.resolve(this.superStore.findAllParents(dymoUri));
    }
    getAllSourcePaths() {
        return Promise.resolve(this.superStore.getAllSourcePaths());
    }
    getSourcePath(dymoUri) {
        return Promise.resolve(this.superStore.getSourcePath(dymoUri));
    }
    addControl(name, type, uri) {
        return Promise.resolve(this.superStore.addControl(name, type, uri));
    }
    setParameter(ownerUri, parameterType, value) {
        return Promise.resolve(this.superStore.setParameter(ownerUri, parameterType, value));
    }
    findParameterValue(ownerUri, parameterType) {
        return Promise.resolve(this.superStore.findParameterValue(ownerUri, parameterType));
    }
    addCustomParameter(ownerUri, paramType) {
        return Promise.resolve(this.superStore.addCustomParameter(ownerUri, paramType));
    }
    setFeature(ownerUri, featureType, value) {
        return Promise.resolve(this.superStore.setFeature(ownerUri, featureType, value));
    }
    findFeatureValue(ownerUri, featureType) {
        return Promise.resolve(this.superStore.findFeatureValue(ownerUri, featureType));
    }
    findAttributeValue(ownerUri, attributeType) {
        return Promise.resolve(this.superStore.findAttributeValue(ownerUri, attributeType));
    }
    setControlParam(controlUri, parameterType, value) {
        return Promise.resolve(this.superStore.setControlParam(controlUri, parameterType, value));
    }
    findControlParamValue(controlUri, parameterType) {
        return Promise.resolve(this.superStore.findControlParamValue(controlUri, parameterType));
    }
    addNavigator(renderingUri, navigatorType, variableUri) {
        return Promise.resolve(this.superStore.addNavigator(renderingUri, navigatorType, variableUri));
    }
    getAttributeInfo() {
        return Promise.resolve(this.superStore.getAttributeInfo());
    }
    findMaxLevel(dymoUri) {
        return Promise.resolve(this.superStore.findMaxLevel(dymoUri));
    }
    toJsonGraph(nodeClass, edgeProperty, previousGraph) {
        return Promise.resolve(this.superStore.toJsonGraph(nodeClass, edgeProperty, previousGraph));
    }
    uriToJsonld(frameUri) {
        return Promise.resolve(this.superStore.uriToJsonld(frameUri));
    }
    ////// EASYSTORE FUNCTIONS /////////
    addValueObserver(subject, predicate, observer) {
        return Promise.resolve(this.superStore.addValueObserver(subject, predicate, observer));
    }
    getValueObserverCount() {
        return Promise.resolve(this.superStore.getValueObserverCount());
    }
    size() {
        return Promise.resolve(this.superStore.size());
    }
    setValue(subject, predicate, value) {
        return Promise.resolve(this.superStore.setValue(subject, predicate, value));
    }
    findSubject(predicate, object) {
        return Promise.resolve(this.superStore.findSubject(predicate, object));
    }
    findSubjects(predicate, object) {
        return Promise.resolve(this.superStore.findSubjects(predicate, object));
    }
    findObject(subject, predicate) {
        return Promise.resolve(this.superStore.findObject(subject, predicate));
    }
    findAllObjects(subject, predicate) {
        return Promise.resolve(this.superStore.findAllObjects(subject, predicate));
    }
    findObjectValue(subject, predicate) {
        return Promise.resolve(this.superStore.findObjectValue(subject, predicate));
    }
    findAllObjectValues(subject, predicate) {
        return Promise.resolve(this.superStore.findAllObjectValues(subject, predicate));
    }
    isSubclassOf(class1, class2) {
        return Promise.resolve(this.superStore.isSubclassOf(class1, class2));
    }
    recursiveFindAllSubClasses(superclassUri) {
        return Promise.resolve(this.superStore.recursiveFindAllSubClasses(superclassUri));
    }
    addTriple(subject, predicate, object) {
        return Promise.resolve(this.superStore.addTriple(subject, predicate, object));
    }
    loadData(data) {
        return Promise.resolve(this.superStore.loadData(data));
    }
    logData() {
        this.superStore.logData();
    }
}
exports.SuperStorePromiser = SuperStorePromiser;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/io/superstore-promiser.js
// module id = 1307
// module chunks = 3